export enum MediaLibraryItemType {
    Link = "link",
    Image = "image",
    Video = "video",
    Document = "document"
}

export enum MediaLibraryItemSubType {
    File = "file",
    Link = "link"
}
